import React, { Component } from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import {
  Table,
  Tag,
  Icon,
  Row,
  Col,
  Collapse,
  Select,
  Button,
  Form,
} from "antd";
import moment from "moment";
import { changeLogLabelMap } from "../../../utils";

import "../style.scss";
import { ChangeLogPayloadType, ChangeLogType } from "../types";

import { ViewportType } from "../../App/types";
import { PaginationInfoType } from "../../BusinessPartnerLists/types";
const { Option } = Select;
const { Panel } = Collapse;

interface IProps extends RouteComponentProps<any> {
  changeLog: null | ChangeLogType[];
  users: string[];
  paginationInfo: PaginationInfoType;
  viewport: ViewportType;
  fetchChangeLog: (payload: ChangeLogPayloadType) => any;
  fetchUsers: () => any;
  setMenuKey: (key: string) => any;
}

interface ChangeLogState {
  selectedUser: string;
}

const formItemLayout = {
  inlineLabel: {
    colon: false,
    labelCol: { span: 8 },
    wrapperCol: { span: 16, gutter: 10 },
  },
};

class ChangeLogComponent extends Component<IProps, ChangeLogState> {
  constructor(props) {
    super(props);

    this.state = {
      selectedUser: undefined,
    };
  }
  componentDidMount() {
    const menuKey = this.props.location.pathname
      .replace(/\//gi, "")
      .replace(/-/gi, " ");
    this.props.setMenuKey(menuKey);
    this.props.fetchUsers();
    const payload = {
      sortBy: "",
      isSortAscending: true,
      page: 1,
      pageSize: this.props.paginationInfo.pageSize,
      genericSearch: "",
      searchData: [],
    };
    this.props.fetchChangeLog(payload);
  }

  getSearchData = (selectedUser: string) => {
    const searchData: {alPerson?: string} = {};
    if (selectedUser) {
      searchData.alPerson = selectedUser || '';
    }
    return searchData;
  };
  handleUserChange = (value: string) => {
    const payload = this.getSearchData(value);
    this.props.fetchChangeLog(payload);

    this.setState({ selectedUser: value });
  };
  // handlPageSizeChange(current: number, size: number) {}
  handleTableChange = (pagination) => {
    const { paginationInfo } = this.props;
    if (
      pagination.current !== paginationInfo.currentPage ||
      pagination.pageSize !== paginationInfo.pageSize
    ) {
      // pagination occured
      const searchData = this.getSearchData(this.state.selectedUser);
      const payload = {
        sortBy: "",
        isSortAscending: true,
        page: pagination.current,
        pageSize: pagination.pageSize,
        genericSearch: "",
        ...searchData,
      };
      this.props.fetchChangeLog(payload);
    }
  };

  render() {
    const columns = [
      {
        title: "BP ID",
        dataIndex: "alBusinessPartnerRef",
        key: "alBusinessPartnerRef",
        width: 70,
      },
      {
        title: "BP Name One",
        dataIndex: "alBpName",
        key: "alBpName",
        sorter: true,
        width: 190,
      },
      {
        title: "Changed By",
        dataIndex: "alPerson",
        key: "alPerson",
        width: 150,
      },
      {
        title: "Date",
        dataIndex: "alDateTime",
        key: "alDateTime",
        width: 150,
        render: (text) => moment(new Date(text)).format("MM-DD-YYYY h:mm:ss"),
      },
      {
        title: "Action",
        dataIndex: "alAction",
        key: "alAction",
      },
    ];
    const { users, changeLog, paginationInfo, viewport } = this.props;
    const expandedRowRender = (record) => {
      const expandableColumns = [
        {
          title: "",
          dataIndex: "fixedCol",
          key: "fixedCol",
          width: 100,
          fixed: true,
        },
      ];
      const beforeRow = { fixedCol: "Before" };
      const afterRow = { fixedCol: "After" };
      record.alChangedValues.forEach((change) => {
        let [label,width,fixed] = [change.alField, 100 , false];
        if(changeLogLabelMap[change.alField]) {
          [label,width,fixed] = [changeLogLabelMap[change.alField].title, changeLogLabelMap[change.alField].width, changeLogLabelMap[change.alField].fixed]
        }
        const column = {
          title: label,
          dataIndex: change.alField,
          key: change.alField,
          width: width,
          fixed: fixed,
        };
        expandableColumns.push(column);
        beforeRow[change.alField] = change.alOldValue;
        afterRow[change.alField] = change.alNewValue;

      })
      
      delete expandableColumns[expandableColumns.length - 1].width;

      const data = [beforeRow, afterRow];
      const tableWidth = expandableColumns.reduce(
        (a, c) => (c.width ? a + +c.width : a),
        0
      );
      const wrapperWidth = viewport.width > 1280 ? 1180 : viewport.width - 100;
      return (
        <div style={{ width: wrapperWidth, overflow: "hidden" }}>
          <Table
            rowKey="fixedCol"
            columns={expandableColumns}
            dataSource={data}
            pagination={false}
            size="small"
            bordered
            scroll={{ x: tableWidth }}
            style={{ border: "1px solid #efefef" }}
          />
        </div>
      );
    };
    return (
      <div className="change-log">
        <h2 className="page-title"> Change Log</h2>
        <Form>
          <Row>
            <Col span={6} offset={18}>
              <Form.Item
                label="Filter by user"
                colon={false}
                {...formItemLayout.inlineLabel}
                className="user-filter"
              >
                <Select
                  allowClear
                  value={this.state.selectedUser}
                  placeholder="All users"
                  showSearch
                  onChange={this.handleUserChange}
                >
                  {users &&
                    users.map((item) => {
                      return (
                        <Option value={item} key={item}>
                          {item}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col>
              <Table
                columns={columns}
                size="small"
                rowKey="clId"
                dataSource={changeLog || []}
                expandedRowRender={expandedRowRender}
                scroll={{ x: "100%" }}
                onChange={this.handleTableChange}
                pagination={{
                  current: paginationInfo.currentPage,
                  pageSize: paginationInfo.pageSize,
                  total: paginationInfo.totalRecords,
                  showSizeChanger: true,
                  pageSizeOptions: ["15", "30", "50", "100"],
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} Business Partners`,
                }}
              />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export default ChangeLogComponent;
